import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  stat: null,
};

// TODO: fetch all the stat
// ...existing code...

// TODO: fetch all the stat
export const fetchStat = createAsyncThunk(
  "fetchStat/stat",
  async (
    { enqueueSnackbar, limit = 10, page = 0, search, year = 2025 },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get(`stat/dashboard`, {
        params: {
          ...(search !== "" && {
            search,
          }),
          limit,
          page: page + 1,
          year, // Add the year parameter
        },
      });

      return {
        data: response.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// ...existing code...

const statlice = createSlice({
  name: "stat",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch stat
    builder.addCase(fetchStat.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchStat.fulfilled, (state, action) => {
      state.fetchLoading = false;
  
      state.stat = action.payload.data;
    });

    builder.addCase(fetchStat.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default statlice.reducer;
